// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2XlWx","rootCenter":"LoadMoreObserver_rootCenter__v2Fuy","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2wcoD"};